import * as React from "react";
import classnames from 'classnames';

const styles = require('./Modal.local.css');

// Modal component helps to dispay content modaly
export class Modal extends React.Component<any, any>
{
    render()
    {
        return (
            <div className='show modal'>
                <div className={`${styles.ModalBackground} modalBackground`}>
                    {this.props.children}
                </div>
            </div>
        );        
    }
}


// WEBPACK FOOTER //
// ./src/components/Modal/Modal.tsx